var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtraceLoginLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1920_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 640
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1920_1",
    "data-name": "Web 1920 \\u2013 1",
    clipPath: "url(#clip-Web_1920_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 640,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M138.349,99.16c-4.363,16.349-4.27,46.935-4.27,46.935q0,46.209,22.713,72.055T216.316,244q38.377,0,79.5-18.014t81.845-47.776a642.394,642.394,0,0,0,81.465-71.288c17.1-17.832,25.446-31.889,49.116-70.835C529.873-1.309,547.33-52.11,556.8-74.394c0,0-18.725,86.841-36.562,135.346-14.072,38.556-28.6,60.788-47.931,91.089-9.87,13.792-33.891,47.252-65.128,78.306-31.348,31.165-70.043,59.968-96.1,79.047q-77.538,56.783-157.425,56.783-69.706,0-110.433-54.041T2.5,164.109q0-82.237,38.377-149.2T166.191-126.462q59.524-50.909,118.265-76.754t104.95-25.846q36.811,0,58.349,16.839t21.538,50.517q0,49.342-36.811,98.293T320.091,33.7C269.7,65.816,156.436,95,138.349,99.16Zm3.562-23.554Q212.4,48.194,262.526,7.467t74.013-77.929q23.888-37.2,23.888-54.433,0-18.014-16.447-18.014-14.1,0-45.818,18.014T233.938-77.9A345.863,345.863,0,0,0,175.589-9.764,220.117,220.117,0,0,0,141.911,75.606Z",
    transform: "translate(40.35 251.443)",
    fill: "#a9e5f0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtraceLoginLogo);
export default __webpack_public_path__ + "static/media/etrace_login_logo.e9bcf9e93e79b34b96e7b4188b01b95b.svg";
export { ForwardRef as ReactComponent };